import { defineComponent as z, ref as c, watch as w, openBlock as d, createElementBlock as p, Fragment as P, renderList as k, normalizeClass as I, createVNode as A, createElementVNode as v, pushScopeId as F, popScopeId as j } from "vue";
import B from "./ghl-ui.es238.js";
import { FixedUnit as H, DynamicUnit as O } from "./ghl-ui.es239.js";
import "./ghl-ui.es240.js";
import X from "./ghl-ui.es166.js";
const T = (i) => (F("data-v-31244a1f"), i = i(), j(), i), Y = { class: "ghl-spacing margin" }, q = /* @__PURE__ */ T(() => /* @__PURE__ */ v("div", { class: "ghl-spacing__title" }, "Margin", -1)), G = ["onMouseover"], J = { class: "ghl-spacing__children" }, K = { class: "ghl-spacing padding" }, Q = /* @__PURE__ */ T(() => /* @__PURE__ */ v("div", { class: "ghl-spacing__title" }, "padding", -1)), W = ["onMouseover"], Z = /* @__PURE__ */ T(() => /* @__PURE__ */ v("div", { class: "padding--children empty" }, null, -1)), ee = z({
  __name: "Spacing",
  props: {
    margin: {
      type: Object,
      default: () => ({
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto"
      })
    },
    marginPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    padding: {
      type: Object,
      default: () => ({
        top: "0px",
        bottom: "0px",
        left: "0px",
        right: "0px"
      })
    },
    paddingPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    marginReadonly: Boolean,
    paddingReadonly: Boolean,
    placement: String
  },
  emits: ["update:value"],
  setup(i, { emit: C }) {
    const g = i, b = C, a = c({
      spacingType: "",
      marginPosition: ""
    }), o = c(!1), m = c(!1), l = c({ margin: g.margin, padding: g.padding }), _ = ({
      spaceType: t,
      position: n,
      value: e,
      unit: s
    }) => {
      s === H.Auto ? (b("update:value", {
        changed: { [t]: { [n]: `${e}` } },
        value: `${e}`
      }), l.value[t][n] = e) : (b("update:value", {
        changed: { [t]: { [n]: `${e}${s}` } },
        value: `${e}${s}`
      }), l.value[t][n] = `${e}${s}`);
    };
    w(
      () => g.margin,
      (t) => {
        l.value.margin = t;
      }
    ), w(
      () => g.padding,
      (t) => {
        l.value.padding = t;
      }
    );
    const r = c(0), $ = (t, n) => {
      o.value || (a.value.marginPosition = n, a.value.spacingType = t, document.body.style.cursor = n === "top" || n === "bottom" ? "ns-resize" : "ew-resize", N());
    }, x = (t) => {
      o.value = t, t || (document.body.style.cursor = "", a.value = {
        spacingType: "",
        marginPosition: ""
      });
    }, N = () => {
      document.addEventListener("mousemove", S), document.addEventListener("mouseup", u), document.addEventListener("mouseleave", u), document.addEventListener("mousedown", E);
    }, E = () => {
      o.value = !0, x(o.value);
    }, S = async (t) => {
      if (o.value) {
        const e = a.value.marginPosition === "top" || a.value.marginPosition === "bottom" ? t.clientY : t.clientX;
        if (r.value === 0)
          r.value = e;
        else {
          const s = e - r.value, y = M(
            l.value[a.value.spacingType][a.value.marginPosition]
          ), f = y.unit;
          let h = y.value;
          if (s !== 0) {
            const U = parseInt(h) + s;
            a.value.spacingType === "padding" && U < 0 ? h = "0" : h = U.toString();
          }
          l.value[a.value.spacingType][a.value.marginPosition] = h + f, r.value = e;
        }
      }
    }, u = () => {
      if (a.value.spacingType && o.value) {
        const t = M(
          l.value[a.value.spacingType][a.value.marginPosition]
        );
        _({
          spaceType: a.value.spacingType,
          position: a.value.marginPosition,
          value: t.value,
          unit: t.unit
        });
      }
      o.value = !1, R(), L(), x(o.value), r.value = 0;
    }, R = () => {
      document.removeEventListener("mousemove", S), document.removeEventListener("mouseup", u), document.removeEventListener("mouseleave", u), document.removeEventListener("mousedown", E), L();
    }, V = () => {
      o.value || u();
    }, L = () => {
      document.body.style.cursor = "";
    }, M = (t) => {
      const n = t.match(/^([+-]?\d*\.?\d+)(px|%|rem|em|vw|vh)?$/);
      if (n) {
        const [, e, s] = n, y = s || O.Pixels, f = parseFloat(e);
        return {
          unit: y,
          value: isNaN(f) ? "0" : f.toString()
        };
      }
      return {
        unit: O.Pixels,
        value: "0"
      };
    }, D = (t) => {
      u(), t ? m.value = !0 : m.value = !1;
    };
    return (t, n) => (d(), p("div", Y, [
      q,
      (d(!0), p(P, null, k(i.marginPositions, (e) => (d(), p("div", {
        class: I(["ghl-spacing__input", [
          `margin--${e}`,
          o.value && (a.value.marginPosition !== e || a.value.spacingType !== "margin") || m.value ? "pointer-events-none" : "",
          a.value.marginPosition === e && a.value.spacingType === "margin" ? "ghl-spacing__input-background-color" : ""
        ]]),
        key: e,
        onMouseover: (s) => $("margin", e),
        onMouseleave: V
      }, [
        A(B, {
          readonly: i.marginReadonly,
          positionType: e,
          spaceType: "margin",
          defaultValue: "auto",
          value: l.value.margin[e],
          "onUpdate:value": _,
          "onUpdate:popOverStatus": D
        }, null, 8, ["readonly", "positionType", "value"])
      ], 42, G))), 128)),
      v("div", J, [
        v("div", K, [
          Q,
          (d(!0), p(P, null, k(i.paddingPositions, (e) => (d(), p("div", {
            class: I(["ghl-spacing__input", [
              `padding--${e}`,
              o.value && (a.value.marginPosition !== e || a.value.spacingType !== "padding") || m.value ? "pointer-events-none" : "",
              a.value.marginPosition === e && a.value.spacingType === "padding" ? "ghl-spacing__input-background-color" : ""
            ]]),
            key: e,
            onMouseover: (s) => $("padding", e),
            onMouseleave: V
          }, [
            A(B, {
              readonly: i.paddingReadonly,
              positionType: e,
              spaceType: "padding",
              defaultValue: "0px",
              value: l.value.padding[e],
              "onUpdate:value": _,
              "onUpdate:popOverStatus": D
            }, null, 8, ["readonly", "positionType", "value"])
          ], 42, W))), 128)),
          Z
        ])
      ])
    ]));
  }
}), ie = /* @__PURE__ */ X(ee, [["__scopeId", "data-v-31244a1f"]]);
export {
  ie as default
};
